<template>
    <div class="more darker moved-right">
        <h6 class="d-flex align-items-center dark pointer m-2 d-flex align-items-center" @click="backToList" style="padding-bottom: 0.0px">
            <i class="ico-arrow-left"></i>
            <span>Go to Filters</span>
        </h6>

        <div class="d-flex flex-column align-items-center pt-5 p-3 text-center" v-if="getIsloadingSelectedEvent">
            <span class="bold">Loading Event</span>
            <loader size="small"></loader>
        </div>

        <div class="relative mt-3 mx-1 border-right-light border-bottom-light border-left-light" v-else-if="event">
            <div class="box border-top-light shadowless">
                <div class="wrapper px-4">
                    <div v-if="event.nameAlias">
                        <span v-if="product">{{ product.name }}</span>
                        <h3 v-if="product">{{ event.nameAlias }}</h3>
                    </div>
                    <h3 v-else-if="product">{{ product.name }}</h3>

                    <!-- Badges -->
                    <div class="mt-2">
                        <img src="~@/assets/images/badges/badge_vr.svg" v-if="event.shareType === 2" v-tooltip="'Virtual Roster'" alt="Virtual Roster" style="height: 20px;">
                        <img src="~@/assets/images/badges/badge_sa.svg" v-if="event.availabilityType == 2 && event.shareType == 1" v-tooltip="'Shared Availability - Resource are shared with more activities'" alt="Shared Availability" style="height: 20px;">
                        <img src="~@/assets/images/badges/badge_sc.svg" v-if="event.hasCutOff == true && event.softCutOff == true" v-tooltip="'Soft Cutoff'" alt="Soft Cutoff" style="height: 20px;">
                        <img src="~@/assets/images/badges/badge_hc.svg" v-if="event.hasCutOff == true && event.softCutOff == false" v-tooltip="'Cutoff'" alt="Cutoff" style="height: 20px;">
                    </div>

                    <links :event="event"></links>
                </div>
            </div>

            <tabs-place :event="event"></tabs-place>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import $ from 'jquery'
import TabsPlace from './EventTabs'
import Links from './Links'
import Loader from '@/tools/loaders/loader1'

export default {
    created() {
        this.eventHub.$on('closeCalendarEventDetails', data => {
            this.backToList();
        });
    },
    computed: {
        ...mapGetters([
            'getSelectedEvent',
            'getIsloadingSelectedEvent',
        ]),
        event() {
            return this.getSelectedEvent;
        },
        product() {
            return this.event.product;
        }
    },
    methods: {
        ...mapActions([
            'updateSelectedEvent',
        ]),
        backToList() {
            var vm = this;

            document
                .querySelectorAll('.fc-event.selected')
                .forEach(el => el.classList.remove('selected'));

            // Animate side panels
            $('.events').removeClass('showingMore overflow-y-auto');
            $('.events .list').removeClass('moved-left');
            $('.events .more').addClass('moved-right');

            // Wait until animation is over, then reset selected event
            setTimeout(function() {
                vm.updateSelectedEvent(null);
            }, 400);
        }
    },
    components: {
        TabsPlace,
        Links,
        Loader
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.events {
    .more {
        width: 100%;
        position: absolute;
        transition: transform 0.4s;

        .bullets {
            position: absolute;
            top: 1rem;
            right: 0.75rem;
        }

        h4 > .ico-arrow-left {
            font-size: 0.5rem;
        }

        .timeline {
            .ico-calendar {
                margin-top: 4px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EventMore.vue?161c5eed